import { ChevronLeft, ChevronRight, ChevronsLeft } from "lucide-react";

interface CursorPagerProps {
  page: number;
  // Omit when unknown: the pager then says "Page N".
  totalPages?: number;
  hasMore: boolean;
  rangeLabel: string;
  pageSize: number;
  pageSizeOptions: number[];
  onPageSizeChange: (size: number) => void;
  onNext: () => void;
  onPrev: () => void;
  onFirst: () => void;
}

// CursorPager is the standalone pager for cursor-paginated lists that
// don't render through DataTable (e.g. the task cards). It matches
// DataTable's built-in pager.
export function CursorPager({
  page,
  totalPages,
  hasMore,
  rangeLabel,
  pageSize,
  pageSizeOptions,
  onPageSizeChange,
  onNext,
  onPrev,
  onFirst,
}: CursorPagerProps) {
  return (
    <div className="flex items-center gap-1 text-xs text-gray-500 dark:text-riot-navy-300">
      <select
        value={pageSize}
        onChange={(e) => onPageSizeChange(Number(e.target.value))}
        className="mr-1 rounded-md border border-gray-300 bg-riot-navy-50 px-1.5 py-1 text-xs text-gray-700 focus:outline-none dark:border-riot-navy-600 dark:bg-riot-navy-700 dark:text-riot-navy-200"
        aria-label="Rows per page"
      >
        {pageSizeOptions.map((size) => (
          <option key={size} value={size}>{size} / page</option>
        ))}
      </select>
      <span className="mr-1 whitespace-nowrap">{rangeLabel}</span>
      <button onClick={onFirst} aria-label="First page" disabled={page <= 1} className="rounded p-1 hover:bg-gray-100 disabled:opacity-30 dark:hover:bg-riot-navy-700">
        <ChevronsLeft size={14} />
      </button>
      <button onClick={onPrev} aria-label="Previous page" disabled={page <= 1} className="rounded p-1 hover:bg-gray-100 disabled:opacity-30 dark:hover:bg-riot-navy-700">
        <ChevronLeft size={14} />
      </button>
      <span className="whitespace-nowrap px-1">
        {totalPages != null ? `${page} of ${Math.max(totalPages, page)}` : `Page ${page}`}
      </span>
      <button onClick={onNext} aria-label="Next page" disabled={!hasMore} className="rounded p-1 hover:bg-gray-100 disabled:opacity-30 dark:hover:bg-riot-navy-700">
        <ChevronRight size={14} />
      </button>
    </div>
  );
}
